export default __webpack_public_path__ + "static/media/graphHelpBtn.db408ab7.svg";